import React from 'react';
import { Helmet } from 'react-helmet';

import { LoadSegmentAnalytics } from 'web-services/segment';
import { bugsnagError } from 'services/bugsnag';

export default function SegmentHelmet () {
  return (
    <Helmet>
      {LoadSegmentAnalytics({
        appEnv: process.env.REACT_APP_ENV,
        exceptionLogger: bugsnagError,
        useHelmetSyntax: true
      })}
    </Helmet>
  );
}
